<template>
    <div>
        <loading :active.sync="loading.content" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <a @click="$router.go(-1)" class="headerButton">
                <!-- <router-link :to="{name:'home'}" class="headerButton"> -->
                    <ion-icon name="chevron-back-outline"></ion-icon>
                <!-- </router-link> -->
                </a>
            </div>
            <div class="pageTitle">{{selectCategory[0].product_name}}</div>
        </div>
        <div id="appCapsule" v-if="loading.content == false">
            <!-- <div class="section inset mt-2">
                <div class="wide-block order-menu pt-2 pb-2 m-0">
                    <div class="menu" v-for="chunks in chunkOperatorPrabayar" :key="chunks.index">
                        <div class="item" v-for="item in chunks" :key="item.id" style="flex:none;">
                            <router-link :to="{name:'prabayar', params:{id:item.id, title:item.product_name, withPrefix:item.withPrefix}}">
                                <img :src="VUE_ENV.VUE_APP_ASSET_URL+'/img/icon/operator/'+item.icon" alt="image" class="imaged" style="width:70%;">
                                <strong>{{ item.product_name }}</strong>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="section tab-content mt-2 mb-2" v-if="selectCategory[0].style_product === 'GRID'">

                <div class="row">
                    <div class="col-4 mb-2" v-for="item in operator" :key="item.id">
                        <router-link :to="{name:'order-prabayar', params:{id:selectCategory[0].id, title:selectCategory[0].product_name, withPrefix:selectCategory[0].withPrefix, operator_data:item}}">
                            <div class="operator-card">
                                <img v-lazyload :src="require('@/assets/Loader-3.png')" :data-src="VUE_ENV.VUE_APP_ASSET_URL+'/img/icon/operator/'+item.icon" alt="image" class="w-100">
                                <div class="text">
                                    <h4 class="title text-center" style="height:55px;">{{ item.product_name }}</h4>
                                    <button class="btn btn-primary rounded shadowed btn-block" style="height:27px;">Pilih</button>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="section tab-content p-0" v-else>
                <ul class="listview image-listview" >
                    <li v-for="item in operator" :key="item.id">
                        <router-link style="cursor:pointer;" class="item pt-2 pb-2" :to="{name:'order-prabayar', params:{id:selectCategory[0].id, title:selectCategory[0].product_name, withPrefix:selectCategory[0].withPrefix, operator_data:item}}">
                            <img v-lazyload :src="require('@/assets/Loader-3.png')" :data-src="VUE_ENV.VUE_APP_ASSET_URL+'/img/icon/operator/'+item.icon" alt="image" class="image">
                            <div class="in">
                                <div>
                                    <b>{{ item.product_name }}</b>
                                    <footer v-if="item.description != undefined">{{item.description}}</footer>
                                </div>
                            </div>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import $axios from './../api.js'
import { mapState } from 'vuex';
export default {
    props: ['styleProduct'],
    data: () => ({
        loading:{
            content: true
        },
        operator: [],
    }),
    created(){

        window.fbq('track', 'ViewContent');
    },
    computed:{
        ...mapState(['customer','toast','VUE_ENV','device','categoryPrabayar']),
        chunkOperatorPrabayar(){
            return window._.chunk(window._.toArray(this.operator),3)
        },
        selectCategory(){
            return this.categoryPrabayar.filter(item => {
                return item.id == this.$route.params.id
            })
        }
    },
    methods: {
        getOperator(){
            $axios.post('/prabayar/operator', {category_id:this.$route.params.id})
            .then((response) => {
                this.operator = response.data.data
                this.loading.content = false
            }).catch(e => {
                this.$store.commit('SET_TOAST', {show:true,message:e.response.data.message,tipe:'default'})
                this.loading.content = false
            })
        },
    },
    mounted() {
        this.getOperator()
    },
}
</script>